export const Gral = (concept, tipoOblea, edit, setSelectedConcept) => {
  const APLICA_A = [
    {
      value: 'APC',
      tipo: 'APC',
    },
    {
      value: 'C',
      tipo: 'C',
    },
  ]

  const CONTROL = [
    {
      id: 0,
      tipo: 'NO',
    },
    {
      id: 1,
      tipo: 'SI',
    },
  ]

  return [
    {
      class: 'textfield',
      label: 'Nombre',
      name: 'oblea_rudac',
      value: concept?.oblea_rudac,
      disabled: true,
      sm: 6,
      xs: 12,
    },
    {
      class: 'textfield',
      label: 'Código',
      name: 'codigo',
      value: concept?.codigo,
      sm: 6,
      xs: 12,
      type: 'number',
      disabled: !edit,
      onChange: (e) => {
        setSelectedConcept({
          ...concept,
          codigo: e.target.value,
        })
      },
    },
    {
      class: 'autocomplete',
      options: APLICA_A,
      name: 'aplica_a',
      label: 'Aplica a',
      optionLabel: `options["tipo"]`,
      optionValue: 'tipo',
      defaultValue: APLICA_A.find((v) => v.tipo === concept?.aplica_a),
      sm: 6,
      xs: 12,
      disabled: !edit,
      onChange: (e) => {
        setSelectedConcept({
          ...concept,
          aplica_a: e.tipo,
        })
      },
    },
    {
      label: 'Tipo de oblea',
      name: 'oblea_tipo',
      options: tipoOblea,
      onChange: (oblea_tipo) => {
        setSelectedConcept({
          ...concept,
          oblea_tipo: oblea_tipo.id,
        })
      },
      value: concept?.oblea_tipo,
      optionLabel: `options["tipo"]`,
      optionValue: 'id',
      sm: 6,
      xs: 12,
      class: 'autocomplete',
      disabled: !edit,
    },
    {
      class: 'autocomplete',
      sm: 6,
      xs: 12,
      options: CONTROL,
      name: 'requiere_control',
      label: 'Requiere control',
      optionLabel: `options["tipo"]`,
      optionValue: 'id',
      defaultValue: CONTROL.find((v) => v.id === concept?.requiere_control),
      disabled: !edit,
      onChange: (e) => {
        setSelectedConcept({
          ...concept,
          requiere_control: e.id,
        })
      },
    },
    {
      class: 'autocomplete',
      sm: 6,
      xs: 12,
      options: (concept?.productos_asociados || []).map((prod) => ({
        ...prod,
        disabled: true,
      })),
      name: 'productos_asociados',
      label: 'Productos asociados',
      optionLabel: `options["producto"]`,
      optionValue: 'id',
      getOptionDisabled: (option) => option.disabled === true,
      disabled: !edit,
    },
  ]
}
